// extracted by mini-css-extract-plugin
export var messageSideLeft = "_l5-1";
export var messageSideRight = "_l5-2";
export var orderLookupBubbleContainer = "_l5-0";
export var submitButton = "_l5-3";